<template lang="pug">
.code-content
  pre.code
    code
      //- Wir loopen über alle Zeilen aus data()
      div(v-for="(line, index) in codeLines", :key="index")
        //- Typ: Keyword (Die Kopfzeile)
        .token.main-line(v-if="line.type === 'keyword'")
          span.keyword {{ line.label }}
          span.object &nbsp;{{ line.value }}
          span {{ line.suffix }}

        //- Typ: Standard Property (String)
        .token(v-if="line.type === 'property'")
          span.name {{ line.name }}
          span : "
          span.value(
            :class="{ clickable: line.clickable }",
            @click="handleAction(line.action)"
          ) {{ line.value }}
          span ",

        //- Typ: Array (Skills)
        .token.skills-line(v-if="line.type === 'array'")
          span.name {{ line.name }}
          span : [
          span(v-for="(item, ix) in line.value", :key="item")
            span &nbsp;"
            span.value {{ item }}
            span "
            span(v-if="ix < line.value.length - 1") ,
          span &nbsp;],

      //- Die Abschlussklammer bleibt statisch oder kommt auch ins Array
      .token.main-line
        span }
</template>

<script>
export default {
  data() {
    return {
      codeLines: [
        { type: "keyword", label: "const", value: "developer", suffix: " = {" },
        {
          type: "property",
          name: "name",
          value: "Gabriel Gnatowski",
          clickable: true,
          action: "about",
        },
        {
          type: "property",
          name: "imprint",
          value: "Impressum",
          clickable: true,
          action: "impressum",
        },
        {
          type: "array",
          name: "skills",
          value: [
            "HTML",
            "PUG",
            "CSS",
            "JS",
            "TS",
            "Vue",
            "NodeJS",
            "Three.JS",
          ],
        },
        {
          type: "property",
          name: "status",
          value: "Retired, but coding...",
          clickable: false,
        },
        {
          type: "property",
          name: "location",
          value: "Emmerich am Rhein",
          clickable: false,
        },
        {
          type: "property",
          name: "contact",
          value: "Get in touch",
          clickable: true,
          action: "contact", // Muss mit dem Namen im Router übereinstimmen
        },
      ],
    };
  },
  methods: {
    handleAction(target) {
      console.log("handle action", target);
      this.$router.push({ name: target }).then(() => {
        this.$forceUpdate();
      });
    },
  },
};
</script>

<style lang="less">
.code {
  margin: 0;
  flex: 1 0;
  display: block;
}
.token {
  margin-left: 1rem;
  text-align: left;
  display: block;
  margin-left: 1rem;
  line-height: 1.6;
  white-space: nowrap;
  word-break: break-all;

  @media (min-width: 768px) {
    margin-left: 4rem; // Zurück zum Desktop-Standard
  }

  &.main-line {
    margin-left: 0;
  }

  span {
    display: inline;
    margin: 0;
    padding: 0;
  }
  .keyword {
    color: #cc6;
  }
  .object {
    color: #c60;
  }
  .name {
    color: #6c6;
  }
  .value {
    color: #8cf;
  }
}

.clickable {
  cursor: pointer;
  text-decoration: underline dotted #ace; // Dezenter Hinweis
  display: inline-block;
  transform-origin: center;
  transition: all 0.2s ease-in-out; // Sanfter Übergang
  position: relative;
  vertical-align: middle;
  z-index: 1;
  &:hover {
    color: #000; // Vue-Grün beim Hover
    background: rgba(184, 184, 184, 0.5);
    border-radius: 4px;
    text-decoration: none;
    transform: scale(3); // translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
    padding: 0.25rem 1rem;
  }
}

.skills-line {
  display: block;
  white-space: normal; // Erlaubt Umbruch zwischen den Anführungszeichen
  word-wrap: break-word;

  .value {
    display: inline-block; // Verhindert, dass ein einzelnes Wort mitten im Buchstaben bricht
  }
}
</style>